import styled from 'styled-components';

export const InfoSideWrapper = styled.div`
	width: 360px;
`;
